import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M23 23H1v-6.696h7.174v.957c0 1.052.86 1.913 1.913 1.913h4.304a1.919 1.919 0 0 0 1.913-1.913v-.957H23V23zM1 16.304l3.348-5.739h3.348m9.565 0h2.391L23 16.304M12.478 1v10.522M8.652 4.826 12.478 1l3.826 3.826" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
